module.exports = __webpack_public_path__ + "static/media/IMG_3620-min.529bad21.JPG";